import React, { useState } from 'react';
import { Alert, Box, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import ConfirmDialog from 'app/shared/widgets/ConfirmDialog';
import companyServices from 'app/services/company-services';

// Los mismos casos que arma Demo::HaulersDemo en el backend, en el mismo orden.
const CASOS = [
    'Escaneo con códigos que existen (1 unidad y varias)',
    'Producto sin código de barras: pickeo a mano',
    'Código que no calza: escanear 2000000000999',
    'Faltante: pickear menos y solicitar autorización',
    'Autorización pendiente',
    'Shopify con envío pagado: definir envío',
    'Mercado Libre: acordar con el vendedor',
    'Retiro en tienda',
    'Pedidos sin planificar',
    'Ruta del conductor, con una entrega firmada',
];

/**
 * "Restablecer datos demo" de la compania de demostracion (solo superadmin). No borra: lo que
 * habia queda archivado (pedidos Eliminados, viajes Finalizados) y se crea el guion de hoy.
 * Si la demo es la compania activa, recarga para que la vista muestre el guion nuevo.
 */
const CompanyResetDemoModal = ({ company, open, onClose, isActive }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [resetting, setResetting] = useState(false);

    const reset = () => {
        setResetting(true);
        companyServices.resetDemo(company.id)
            .then((data) => {
                enqueueSnackbar(`Demo restablecida: ${data.created.orders} pedidos y ${data.created.trips} viajes de hoy`, { variant: 'success' });
                onClose();
                if (isActive) window.location.reload();
            })
            .catch((err) => {
                enqueueSnackbar(err?.response?.data?.error || 'No fue posible restablecer la demo', { variant: 'error' });
            })
            .finally(() => setResetting(false));
    };

    return (
        <ConfirmDialog
            open={open}
            title="Restablecer datos demo"
            message={<>
                <Typography variant="body2">
                    Los pedidos y viajes que hay hoy en <strong>{company?.name}</strong> quedan archivados
                    (pedidos Eliminados, viajes Finalizados) y se crea el guion de demostración con fecha de hoy:
                </Typography>
                <Box component="ol" sx={{ mt: 1, mb: 1, pl: 3 }}>
                    {CASOS.map((caso) => <li key={caso}><Typography variant="body2">{caso}</Typography></li>)}
                </Box>
                <Alert severity="info">No se borra nada ni sale ningún correo o aviso.</Alert>
            </>}
            confirmText="Restablecer"
            loading={resetting}
            onConfirm={reset}
            onClose={onClose}
        />
    );
};

export default CompanyResetDemoModal;
